import api from '../../libs/api'
import { getP } from 'redux-polyglot'

export const DISMISS_LOGS_ERROR = 'TICKETS_DETAILS/DISMISS_LOGS_ERROR'
export const dismissLogsError = () => ({
  type: DISMISS_LOGS_ERROR,
})

export const INIT_TICKET_DETAILS = 'TICKETS_DETAILS/INIT_APP_REQUEST'

export const initTicket = () => ({
  type: INIT_TICKET_DETAILS,
})

export const initTicketDetails = id => dispatch => {
  return Promise.all([dispatch(initTicket()), dispatch(loadTicketDetails(id))])
}

export const FETCH_TICKET_DETAILS_REQUEST = 'TICKETS/FETCH_TICKET_DETAILS_REQUEST'
export const FETCH_TICKET_DETAILS_SUCCESS = 'TICKETS/FETCH_TICKET_DETAILS_SUCCESS'
export const FETCH_TICKET_DETAILS_FAILURE = 'TICKETS/FETCH_TICKET_DETAILS_FAILURE'

export const fetchTicketDetailsRequest = () => ({
  type: FETCH_TICKET_DETAILS_REQUEST,
})

export const fetchTicketDetailsSuccess = ticket => {
  return {
    type: FETCH_TICKET_DETAILS_SUCCESS,
    payload: {
      ticket,
    },
  }
}

export const fetchTicketDetailsFailure = error => ({
  type: FETCH_TICKET_DETAILS_FAILURE,
  payload: error instanceof Error ? error : new Error(error),
  error: true,
})

export const FOCUS_LOG = 'TICKETS/FOCUS_LOG'
export const focusLog = id => ({
  type: FOCUS_LOG,
  payload: {
    id,
  },
})
export const FOCUS_LOG_POSITION = 'TICKETS/FOCUS_LOG_POSITION'
export const focusLogPosition = position => ({
  type: FOCUS_LOG_POSITION,
  payload: {
    position,
  },
})

export const selectTicket = id => (dispatch, getState) => {
  dispatch(selectTicketRequest(id))
}

export const loadTicketDetails = id => (dispatch, getState) => {
  dispatch(fetchTicketDetailsRequest())
  return api
    .getTicket(id)
    .then(res => res.json())
    .then(
      response => {
        if (response.status === 200) {
          let ticket = {
            logs: [],
            detail: [],
          }
          ticket.detail['id'] = response.ticket.id
          ticket.detail['title'] = response.ticket.title
          ticket.detail['description'] = response.ticket.description
          ticket.detail['user_id'] = response.ticket.user_id
          ticket.detail['user_username'] = response.ticket.user_username
          ticket.detail['status'] = response.ticket.status
          ticket.detail['timestamp'] = response.ticket.timestamp
          ticket.detail['user_image'] = response.ticket.user_image

          ticket.logs = response.ticket.logs

          return dispatch(fetchTicketDetailsSuccess(ticket))
        } else {
          return dispatch(fetchTicketDetailsFailure(response.reason))
        }
      },
      () =>
        dispatch(
          fetchTicketDetailsFailure(
            getP(getState()).t('support_app.error_loading_ticket_detail', {
              _: 'An error occurred while retrieving ticket details',
            })
          )
        )
    )
}
